/* Common js functions - must be on top  of all js files */
function resize_homepage() {
    const windowH = window.innerHeight; //Firefox
    const sidebar = document.getElementById("sideMenuWrapper");
    const sidebarMenu = document.getElementById("sideMenuWrapper");
    const extraOffset = 58;

    try {
        const height = windowH - sidebarMenu.getBoundingClientRect().top - extraOffset;
        const lastUpdatesContainer = document.getElementById("lastUpdatesContainer");

        if (lastUpdatesContainer) {
            lastUpdatesContainer.style.height = (height - 442) + "px";
        }
    } catch (e) {
        console.log("An Error occurred while resizing homepage", e);
    }
}
